/**
 * © [2023]  Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ResearchExistingCMS64ReportTable from './ResearchExistingCMS64ReportTable';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import {
  RESEARCH_CMS64_HEAD,
  QUARTER_END_DATE_MAPPING,
} from '../utils/tableHead';
import {
  setCms64Data,
  setCms64ResearchData,
  setPaymentsData,
  setCMSApiResponse,
} from '../../ReqInitCorrectCmsReport/Store/actions';
import Spinner from '../../../../../../SharedModules/Spinner/Spinner';

const ResearchExistingCMS64ReportDetails = ({}) => {
  const dispatch = useDispatch();
  const createCms64Data = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const gridData = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.gridData
  );
  const responseCMSRpt = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.responseCMSRpt
  );
  const rebatePrgByCMS = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.rebatePrgByCMS?.data
  );
  const [reportData, setReportData] = useState([]);
  const [rebateQtr, setRebateQtr] = useState([]);
  const [gridHeader, setGridHeader] = useState([]);
  const [displayGrid, setDisplayGrid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const history = useHistory();
  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };
  const handleResearchInvoiceAmount = () => {
    navigateToPage(
      '/researchExistingCMS64InvoiceAmount',
      'Research CMS 64 Inv Amounts'
    );
  };
  const handleResearchAdjustments = () => {
    navigateToPage(
      '/researchExistingCMS6Adjustments',
      'Research CMS 64 Inv Adjustments'
    );
  };
  const handleResearchPayments = () => {
    navigateToPage(
      '/researchExistingCMS6Payments',
      'Research CMS 64 Inv Payments'
    );
  };
  useEffect(() => {
    (async () => {
      const payload = {
        qtr: createCms64Data.quarter,
        rpc: [
          createCms64Data?.selectBy == 'single'
            ? createCms64Data.rebateProgramCd
            : rebatePrgByCMS[0]?.rebateProgramCode,
        ],
        checkPayeeCd: createCms64Data.rebateProgramSelObj[0]?.checkPayeeCd,
      };
      if (
        !responseCMSRpt.response ||
        responseCMSRpt.payload?.qtr !== createCms64Data.quarter ||
        responseCMSRpt.payload?.rpc[0] !== createCms64Data.rebateProgramCd
      ) {
        try {
          setLoading(true);
          const response = await axios.post(
            `${serviceEndPoint.GET_CMS64_REPORT}`,
            payload
          );
          setLoading(false);
          setRebateQtr(response?.data.rebateQtr);
          const responseApi = {
            response: response,
            payload: payload,
          };
          dispatch(setCMSApiResponse(responseApi));
          const transformedData = transformData(response?.data);
          dispatch(setCms64ResearchData(transformedData));
          setReportData(transformedData);
        } catch (e) {
          setLoading(false);
        }
      } else {
        const { response } = responseCMSRpt;

        setRebateQtr(response?.data.rebateQtr);
        const transformedData = transformData(response?.data);

        setReportData(transformedData);
      }
    })();
  }, [
    createCms64Data.quarter,
    createCms64Data.rebateProgramCd,
    createCms64Data.rebateProgramSelObj[0]?.checkPayeeCd,
  ]);

  const transformData = (response) => {
    const mappedData = {
      OPMT: [],
      LCB: [],
      toQtr: [],
      fromQtr: [],
      payments: [],
      totalInvAdjs: [],
      InvAdjsFinalTotal: '',
      InvAmountFinalTotal: '',
    };
    const transFormedData = [
      {
        name: '1.Balance as of Beginning of the Quarter',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '2.Adjustments to Previously Reported Rebates',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '3.Rebates Established this Quarter',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '4.Subtotal',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '5.Rebates Reported on this Expenditure Report',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '6.Balances As of the End of the Quarter',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: 'QROA Change Amount',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: '',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
      {
        name: 'Interest Received',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        previousQtr: '',
        finalTotal: '',
      },
    ];
    if (response) {
      // response.rebateQtr.forEach((item, index) => {
      //   const key = `Q${index + 1}`;
      //   transFormedData[0][key] = item;
      // });
      mapDataFromResposne(response.col1, 'Q1', transFormedData);
      mapDataFromResposne(response.col2, 'Q2', transFormedData);
      mapDataFromResposne(response.col3, 'Q3', transFormedData);
      mapDataFromResposne(response.col4, 'Q4', transFormedData);
      // Previour Qtr col mapping
      mapDataFromResposne(response.col5, 'Q5', transFormedData);

      transFormedData.forEach((item, index) => {
        // if (index > 0) {
        item.finalTotal = item.Q1 + item.Q2 + item.Q3 + item.Q4 + item.Q5;
        // }
      });
      mapPaymentsData(response.col1, mappedData);
      mapPaymentsData(response.col2, mappedData);
      mapPaymentsData(response.col3, mappedData);
      mapPaymentsData(response.col4, mappedData);
      mapPaymentsData(response.col5, mappedData);

      let count = 0;
      const paymentsObject = transFormedData[4];
      for (const property in paymentsObject) {
        if (count > 0 && count < 6) {
          mappedData.payments.push(paymentsObject[property]);
        }
        count++;
      }
      count = 0;
      const invTotalObject = transFormedData[1];
      for (const property in invTotalObject) {
        if (count > 0 && count < 6) {
          mappedData.totalInvAdjs.push(invTotalObject[property]);
        }
        count++;
      }
      mappedData.InvAdjsFinalTotal =
        parseInt(invTotalObject.finalTotal) < 0
          ? `(${Math.abs(invTotalObject.finalTotal)})`
          : invTotalObject.finalTotal;
      mappedData.InvAmountFinalTotal = transFormedData[3].finalTotal;
      dispatch(setPaymentsData(mappedData));
    }

    return transFormedData;
  };
  const mapDataFromResposne = (col, key, transFormedData) => {
    let row2Val = 0;
    let row5Val = 0;
    Object.keys(col).forEach((itemKey) => {
      let item = col[itemKey];
      switch (item.rowNum) {
        case 1:
          transFormedData[item.rowNum - 1][key] = item.total;
          break;
        case 2:
          row2Val += item.total;
          break;
        case 3:
          transFormedData[item.rowNum - 1][key] = item.total;
          break;
        case 4:
          row5Val += item.total;
          break;

        // case 8:
        //   row5Val += item.total;
        //   break;
        // case 9:
        //   row2Val += item.total;
        //   row5Val += item.total;
        //   break;
        // case 10:
        //   row2Val += item.total;
        //   break;
        // case 11:
        //   row5Val += item.total;
        //   break;

        case 12:
          transFormedData[8][key] = item.total;
          break;
        case 13:
          transFormedData[6][key] = item.total;
          break;
      }
    });
    transFormedData[1][key] = row2Val;
    transFormedData[4][key] = row5Val;
    transFormedData[3][key] =
      transFormedData[0][key] +
      transFormedData[1][key] +
      transFormedData[2][key];
    transFormedData[5][key] = transFormedData[3][key] - transFormedData[4][key];
  };
  const mapPaymentsData = (col, mappedData) => {
    col.forEach((item) => {
      switch (item.rowNum) {
        case 8:
          mappedData.OPMT.push(item.total);
          break;
        case 11:
          mappedData.LCB.push(item.total);
          break;
        case 9:
          mappedData.toQtr.push(item.total);
          break;
        case 10:
          mappedData.fromQtr.push(item.total);
          break;
      }
    });
  };

  useEffect(() => {
    let headIndex = 3;
    const headerVal = RESEARCH_CMS64_HEAD;
    if (rebateQtr) {
      rebateQtr.forEach((item) => {
        const endDateQtr = convertQuarterToendDate(item);
        if (headerVal[headIndex].headerName.includes('Qtr Ending')) {
          headerVal[
            headIndex
          ].headerName = `Qtr Ending (${endDateQtr}) ${item}`;
          headIndex++;
        }
      });
      setGridHeader(headerVal);
      setDisplayGrid(false);
    }
  }, [rebateQtr]);
  useEffect(() => {
    if (rebateQtr.length > 0) {
      setDisplayGrid(true);
    }
  }, [gridHeader, rebateQtr]);
  useEffect(() => {}, [reportData]);
  const convertQuarterToendDate = (qtr) => {
    const splitData = qtr.split('Q');
    const quater = `Q${splitData[0]}`;
    const year =
      splitData[0] == '4' ? parseInt(splitData[1]) + 1 : splitData[1];
    return `${QUARTER_END_DATE_MAPPING[quater]}${year}`;
  };

  return (
    <div className='tabs-container'>
      <div className='tBillPanel  custom-check'>
        {loading && <Spinner load={loading} />}
        <CustomSeparator
          parent1='System'
          parent2='Technical Window'
          parent3='Online Fixes'
          parent4='Research Existing CMS64 Rpt'
        />
        <div className='panel tBillPanel-space pb-0'>
          <div className='panel mb-3'>
            <div className='row'>
              <div style={{ width: '100%' }}>
                <fieldset className='custom-fieldset'>
                  {!fullScreen && (
                    <div className='row'>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label={
                                  createCms64Data?.selectBy === 'single'
                                    ? 'Rebate Program'
                                    : 'Group'
                                }
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{ id: 'rbtProg' }}
                                id='rbtProg'
                                name='rbtProg'
                                value={
                                  createCms64Data?.selectBy === 'single'
                                    ? createCms64Data?.rebateProgramCd
                                    : createCms64Data?.cmsReportingGrps
                                }
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='State'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{ id: 'state' }}
                                id='state'
                                name='state'
                                value='Maryland'
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Calender/Rebate Quarter'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{ id: 'quarter' }}
                                id='quarter'
                                name='quarter'
                                value={createCms64Data.quarter}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              {createCms64Data.rebateProgramSelObj[0]
                                ?.cms64AgencyName?.length > 35 ? (
                                <OverlayTrigger
                                  placement='bottom'
                                  overlay={
                                    <Tooltip id='com-tooltip'>
                                      {
                                        createCms64Data.rebateProgramSelObj[0]
                                          ?.cms64AgencyName
                                      }
                                    </Tooltip>
                                  }
                                >
                                  <TextField
                                    label='Agency'
                                    fullWidth
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    inputProps={{ id: 'agency' }}
                                    id='agency'
                                    name='agency'
                                    value={`${createCms64Data.rebateProgramSelObj[0]?.cms64AgencyName.substring(
                                      0,
                                      35
                                    )} ...`}
                                    disabled
                                  />
                                </OverlayTrigger>
                              ) : (
                                <TextField
                                  label='Agency'
                                  fullWidth
                                  placeholder=''
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{ id: 'agency' }}
                                  id='agency'
                                  name='agency'
                                  value={
                                    createCms64Data.rebateProgramSelObj[0]
                                      ?.cms64AgencyName
                                  }
                                  disabled
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-sm-4 mt-2'>
                        <div className='form-wrapper p-0 mt-2'>
                          <div className='mui-custom-form input-md field-xl'>
                            <div>
                              <TextField
                                label='Quarter Ended'
                                fullWidth
                                placeholder=''
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                inputProps={{ id: 'quarterended' }}
                                id='quarterended'
                                name='quarterended'
                                value={responseCMSRpt?.response?.data.endDate}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        {reportData && displayGrid === true ? (
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
            <ResearchExistingCMS64ReportTable
              reportData={reportData}
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              rebateQtr={rebateQtr}
              header={gridHeader}
              handleResearchInvoiceAmount={handleResearchInvoiceAmount}
              handleResearchAdjustments={handleResearchAdjustments}
              handleResearchPayments={handleResearchPayments}
              responseCMSRpt={responseCMSRpt?.response?.data.endDate}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default ResearchExistingCMS64ReportDetails;
